import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'animate.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'bootstrap/dist/css/bootstrap.css'
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.js'
import 'ant-design-vue/dist/antd.css';

AOS.init();

createApp(App).use(bootstrap).use(store).use(router).mount('#app')
